import { REPORT_TYPES } from '../../../shared/utils/constants';

const validate = (values) => {
  const errors = {};
  if (!values.students) {
    errors.students = 'Esse campo não pode ficar vazio';
  }

  if (!values.classesnames) {
    errors.classesnames = 'Esse campo não pode ficar vazio';
  }

  if (!values.date) {
    errors.date = 'Informe a data';
  }

  if (!values.initialDate) {
    errors.initialDate = 'Informe a data inicial';
  }

  if (!values.finalDate) {
    errors.finalDate = 'Informe a data final';
  }
  if (!values.month) {
    errors.month = 'Informe o mês';
  }

  if (values.type === REPORT_TYPES.RELA_COVIDF) {
    if (!values.item || !values.item.value) {
      errors.item = 'Selecione o item desejaso para gerar o relatório';
    }
  }
  if (!values.responsibleFinancial) {
    errors.responsibleFinancial = 'Esse campo não pode ficar vazio';
  }
  if (!values.year) {
    errors.year = 'Esse campo não pode ficar vazio';
  }
  return errors;
};

export default validate;
